import striptags from 'striptags';
import {
  getTitle,
  getTeamSelectorNodes,
  mergeLinkWithIngredients,
  extractIngredientsFromList,
} from '../helpers';
import {
  getActions,
  getClickActivity,
  getCommonAnalyticsProps,
  getSectionHeadlinePlacements,
} from '../helpers/analytics';
import { analyticsProperties } from '../../../analytics/constants';
import { getCommonProps } from '../helpers/commonHelpers';

export const prepareCardData = (teamSelectorCard, { nodes }) => ({
  ...getCommonProps(teamSelectorCard),
  items: getTeamSelectorNodes({ id: teamSelectorCard?.id, nodes }),
  sectionHeadline: getTitle(teamSelectorCard),
});

export const prepareTranslations = (translationsStrings = {}) => ({
  labels: {
    seeAllLabel: translationsStrings.team_selector_see_all,
    seeLessLabel: translationsStrings.team_selector_see_less,
  },
});

export const mergeProperties = ({
  cardData,
  urls = [],
  translations = {},
}) => ({
  ...cardData,
  ...translations,
  items: cardData.items.map(item =>
    mergeLinkWithIngredients({ action: item, property: 'url', urls }),
  ),
});

export const getUrlIngredients = card =>
  extractIngredientsFromList(card?.items);

export const getAnalyticsPlacements = card => [
  ...getSectionHeadlinePlacements(card),
  getCommonAnalyticsProps(card),
];

export const getAnalyticsActions = card => [
  ...getActions(card.sectionHeadline.actions),
  ...card.items.map((item, index) => ({
    id: item.id,
    [analyticsProperties.CTA_TITLE]: striptags(item.label),
    [analyticsProperties.CLICK_ACTIVITY]: getClickActivity(
      item.destinationType,
      index + 1,
      item.label,
    ),
    [analyticsProperties.ASSET_ID]: item.assetId,
  })),
];

export { getBuyingToolsIngredients } from './common';
